import { Component, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { TopbarComponent } from '../../shared/components/topbar/topbar.component';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, TopbarComponent],
  template: `
    <div class="min-h-screen bg-gray-50">
      <app-topbar #topbar />
      <app-sidebar #sidebar />
      <div
        class="pt-20 transition-all duration-300 lg:ml-64"
        [class.lg:ml-20]="sidebar.collapsed()"
      >
        <main class="p-4 sm:p-6 lg:p-8 animate-slide-up">
          <router-outlet />
        </main>
      </div>
    </div>
  `,
})
export class DashboardLayoutComponent implements AfterViewInit {
  @ViewChild('sidebar') sidebar!: SidebarComponent;
  @ViewChild('topbar') topbar!: TopbarComponent;
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.topbar.sidebarRef = this.sidebar;
    this.cdr.markForCheck();
  }
}
